import React, { Component } from 'react';
import './ErrorPage.css';
import Title from '../../components/title/Title';
import Description from '../../components/description/Description';
import Button from '../../components/button/Button';

class ErrorPage extends Component {
    render() {
        var title = this.props.title || '';
        var description = this.props.description || '';
        var buttonText = this.props.buttonText || '';
        var buttonTo = this.props.buttonTo || '';
        var buttonClick = this.props.buttonClick || function() { };
        
        var buttonProps = {
            onClick: buttonClick
        };
        
        if(buttonTo !== '') buttonProps.to = buttonTo;
        
        return <div className="ErrorPage WidthLimit">
        <div className="ErrorPageChild">
        <Title text={title} size="Huge" />
        <Description text={description} size="Huge" />
        {React.cloneElement(<Button text={buttonText} />, buttonProps)}
        </div>
        </div>;
    }
}

export default ErrorPage;
